// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EServicesOrchestratorServicePublicNewPathModelsMedicalCardFinderPrescriberAddressModel } from './eServicesOrchestratorServicePublicNewPathModelsMedicalCardFinderPrescriberAddressModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description Gets or sets the Prescriber.
*/
export class EServicesOrchestratorServicePublicNewPathModelsMedicalCardFinderPrescriberModel {
    'address'?: EServicesOrchestratorServicePublicNewPathModelsMedicalCardFinderPrescriberAddressModel | null;
    /**
    * @description Gets or sets the prescriber fax.
    */
    'fax'?: string | null;
    /**
    * @description Gets or sets the first name.
    */
    'firstName'?: string | null;
    /**
    * @description Gets or sets the last name.
    */
    'lastName'?: string | null;
    /**
    * @description Gets or sets the npi.
    */
    'npi'?: string | null;
    /**
    * @description Gets or sets the phone.
    */
    'phone'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof EServicesOrchestratorServicePublicNewPathModelsMedicalCardFinderPrescriberModel>> = [
        {
            "name":     "address",
            "baseName": "address",
            "type":     "EServicesOrchestratorServicePublicNewPathModelsMedicalCardFinderPrescriberAddressModel"
        },
        {
            "name":     "fax",
            "baseName": "fax",
            "type":     "string"
        },
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
        {
            "name":     "npi",
            "baseName": "npi",
            "type":     "string"
        },
        {
            "name":     "phone",
            "baseName": "phone",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return EServicesOrchestratorServicePublicNewPathModelsMedicalCardFinderPrescriberModel.attributeTypeMap;
    }
}
